import React from 'react';
import { FadeIn } from './FadeIn';
export function ProductReveal() {
  const levels = [{
    name: 'Iniciación (4-7 años)',
    color: 'bg-green-500/20 text-green-400 border-green-500/30',
    dot: '🟢'
  }, {
    name: 'Principiante (8+)',
    color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    dot: '🟡'
  }, {
    name: 'Intermedio Temprano',
    color: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    dot: '🟠'
  }, {
    name: 'Intermedio',
    color: 'bg-red-500/20 text-red-400 border-red-500/30',
    dot: '🔴'
  }];
  const checklist = ['Por nivel y edad', '24+ piezas curadas listas', 'Evaluación + rúbricas por nivel', 'Teoría + Lectura + Técnica + Recital'];
  return <section className="bg-navy-800 py-20 md:py-24 relative overflow-hidden" data-id="element-216">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-217"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10" data-id="element-218">
        <FadeIn className="max-w-4xl mx-auto border border-gold/30 rounded-2xl p-6 sm:p-10 md:p-14 bg-navy-900/80 backdrop-blur-sm shadow-[0_0_50px_rgba(212,180,100,0.1)]" data-id="element-219">
          <div className="text-center mb-10" data-id="element-220">
            <span className="inline-block text-gold text-xs sm:text-sm font-bold uppercase tracking-widest mb-6 px-4 py-1.5 border border-gold/20 rounded-full bg-gold/5" data-id="element-221">
              🏆 Sistema N°1 para Profesores de Piano en Argentina
            </span>

            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.15] text-white mb-2" data-id="element-222">
              🎹 PIANO LISTO™
            </h2>
            <h2 className="font-display font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-[1.15] mb-6" data-id="element-223">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-light via-gold to-gold-dark" data-id="element-224">
                MEGAPACK PARA PROFESORES
              </span>
            </h2>

            <p className="font-accent italic text-xl sm:text-2xl md:text-3xl text-gray-300 mb-6" data-id="element-225">
              6 Tomos + 6 Bonos — 4 niveles — Todo resuelto.
            </p>

            <p className="text-sm sm:text-base md:text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed" data-id="element-226">
              +360 páginas · Planificación anual · Repertorio curado · Sistema
              técnico · Teoría lúdica · Recital chequeado · Comunicación con
              familias. Funciona desde hoy.
            </p>
          </div>

          <div className="bg-navy-800/50 rounded-xl p-6 sm:p-8 border border-white/5 text-center" data-id="element-227">
            <h3 className="font-display font-bold text-xl sm:text-2xl text-white mb-6 tracking-wide" data-id="element-228">
              6 TOMOS COMPLETOS
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-left max-w-2xl mx-auto" data-id="element-229">
              {checklist.map((item, i) => <div key={i} className="flex items-center gap-3 text-gray-200" data-id="element-230">
                  <span className="text-success text-lg sm:text-xl shrink-0" data-id="element-231">
                    ✅
                  </span>
                  <span className="text-sm sm:text-base md:text-lg" data-id="element-232">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}